import { render } from "./package-item.vue?vue&type=template&id=64c8878e"
import script from "./package-item.vue?vue&type=script&lang=js"
export * from "./package-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__